import Login from 'components/Login';
import TermsAndConditions from 'components/TermsAndConditions';
import ForgottenPassword from 'components/ForgottenPassword';
import ResetPassword from 'components/ResetPassword';
import Home from 'components/Home';
import Dashboard from 'containers/Dashboard';
import CannedDashboard from 'containers/CannedDashboard';

import Portfolios from 'containers/Portfolios';
import Holdings from 'containers/Holdings';
import PeerGroups from 'containers/PeerGroups';
import Instruments from 'containers/Instruments';
import UserDashboards from 'containers/UserDashboards';
import DashboardsSharedWithMe from 'containers/DashboardsSharedWithMe';
import SearchResults from 'containers/SearchResults';
import Sandbox from './Sandbox';
import SearchScreen from 'containers/ReportingGenerator/ReportingGenerator';

export const restrictedRoutes = [
  {
    path: '/',
    component: Home,
    exact: true
  },
  {
    path: '/dashboard/:id?',
    component: Dashboard
  },
  {
    path: '/canned/:masterObjectId/:id?',
    component: CannedDashboard
  },
  {
    path: '/sandbox',
    component: Sandbox
  },
  {
    path: '/portfolios',
    component: Portfolios
  },
  {
    path: '/holdings',
    component: Holdings
  },
  {
    path: '/my-dashboards',
    component: UserDashboards
  },
  {
    path: '/shared-dashboards',
    component: DashboardsSharedWithMe
  },
  {
    path: '/search-results',
    component: SearchResults
  },
  {
    path: '/peer-groups',
    component: PeerGroups
  },
  {
    path: '/instruments',
    component: Instruments
  },
  {
    path: '/reporting-generator',
    component: SearchScreen
  }
];

export const authRoutes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/forgot-password',
    component: ForgottenPassword
  },
  {
    path: '/terms-and-conditions',
    component: TermsAndConditions
  },
  {
    path: '/reset-password:resetId?',
    component: ResetPassword
  }
];
